import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ProductoModel } from '../models/ProductoModel';
import { obtenerProductosService, obtenerProductoPorIdService } from '../../../../service/catalogos/Productos';

export const useObtenerProductos = (reload: number) => {
  const [data, setData] = useState<ProductoModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      const res = await obtenerProductosService()
        .then()
        .catch(() => {
          setLoadingRequest(false);
          history.push('/error/500');
        });
      if (res) {
        setData(res);
        setLoadingRequest(false);
      }
    };
    fetchData();
  }, [reload]);

  return { data, loadingRequest };
};

export const useObtenerProductoPorId = (id: number) => {
  const initModel: ProductoModel = { id: 0, nombre: '', tipo: '', unidad: '', costo_sugerido: 0, util_proveedor: null };
  const [initValues, setInitValues] = useState<ProductoModel>(initModel);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const res = await obtenerProductoPorIdService(id)
        .then()
        .catch(() => {
          history.push('/error/500');
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchData();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};
